"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = exports.DynamicValues = void 0;
const interpreter_1 = require("./interpreter");
const context_1 = require("./interpreter/context");
const types_1 = require("./types");
const utils_1 = require("./utils");
class DynamicValues {
    constructor(defaults, environment, handlers) {
        this.defaults = defaults;
        this.environment = environment;
        this.handlers = handlers;
    }
    featureFlag(name, on, off, context) {
        const defaultValue = this.defaults[name];
        if (typeof defaultValue !== 'boolean') {
            this.handlers.sendError(`Attempted to grab boolean
      for Dynamic Value ${name} which has mismatching default`);
            return null;
        }
        const resolvedValue = this.interpret(name, context, types_1.ValueNodeReturnType.Boolean, defaultValue, utils_1.isBoolean);
        return resolvedValue ? on() : off();
    }
    getBoolean(name, context) {
        const defaultValue = this.defaults[name];
        if (typeof defaultValue !== 'boolean') {
            this.handlers.sendError(`Attempted to grab boolean
      for Dynamic Value ${name} which has mismatching default`);
            return null;
        }
        return this.interpret(name, context, types_1.ValueNodeReturnType.Boolean, defaultValue, utils_1.isBoolean);
    }
    getJson(name, context) {
        const defaultValue = this.defaults[name];
        if (typeof defaultValue === 'undefined' ||
            typeof defaultValue === 'boolean' ||
            typeof defaultValue === 'string' ||
            typeof defaultValue === 'number') {
            this.handlers.sendError(`Attempted to grab json
      for Dynamic Value ${name} which has mismatching default`);
            return null;
        }
        return this.interpret(name, context, types_1.ValueNodeReturnType.Json, defaultValue, utils_1.isJson);
    }
    getString(name, context) {
        const defaultValue = this.defaults[name];
        if (typeof defaultValue !== 'string') {
            this.handlers.sendError(`Attempted to grab string
      for Dynamic Value ${name} which has mismatching default`);
            return null;
        }
        return this.interpret(name, context, types_1.ValueNodeReturnType.String, defaultValue, utils_1.isString);
    }
    getFloat(name, context) {
        const defaultValue = this.defaults[name];
        if (typeof defaultValue !== 'number') {
            this.handlers.sendError(`Attempted to grab string
      for Dynamic Value ${name} which has mismatching default`);
            return null;
        }
        return this.interpret(name, context, types_1.ValueNodeReturnType.Float, defaultValue, utils_1.isFloat);
    }
    getInt(name, context) {
        const defaultValue = this.defaults[name];
        if (typeof defaultValue !== 'number') {
            this.handlers.sendError(`Attempted to grab string
      for Dynamic Value ${name} which has mismatching default`);
            return null;
        }
        return this.interpret(name, context, types_1.ValueNodeReturnType.Int, defaultValue, utils_1.isInteger);
    }
    interpret(name, context, type, defaultValue, typeValidator) {
        const config = this.handlers.getOnlineConfiguration(this.environment.serviceName, name, this.environment.onlineConfigPrefix);
        if (config == null) {
            return defaultValue;
        }
        if (type !== config.default.returnType) {
            this.handlers.sendError(`Attempted to grab type ${type} for Dynamic Value
         ${name} which is of type ${config.default.returnType}`);
            return null;
        }
        const { value, trackingData } = interpreter_1.interpret(config, new context_1.Context(this.environment, context, name, this.handlers.sendError, config.bucketingMethod), typeValidator);
        if (utils_1.shouldTrack(config)) {
            this.handlers.trackExposure({
                calling_context: 'JS DVL',
                bucket_key: '',
                bucket_key_type: '',
                experiment_name: name,
                experiment_version: `${config.version || 'unknown version'}`,
                service: `${this.environment.serviceName}`,
                result: JSON.stringify(value),
                tag: '',
                resolution_log: [],
                exposure_time: Date.now(),
                ...trackingData,
            });
        }
        return value == null ? defaultValue : value;
    }
}
exports.DynamicValues = DynamicValues;
/**
 * Initialize function exposed to clients accessing this library
 * @param node
 * @param context
 */
function initialize(defaults, environment, handlers) {
    return new DynamicValues(defaults, environment, handlers);
}
exports.initialize = initialize;
//# sourceMappingURL=dynamicValues.js.map